"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.$postForwardRule = exports.$postBulkForwardsRules = exports.$patchForwardRule = exports.$getForwardRule = exports.$getAllForwardsRules = void 0;
var _oldHttpClient = require("../../apiClient/oldHttpClient");
var base = '/sip-accounts';
var $getAllForwardsRules = _sipAccount => (0, _oldHttpClient.apiClient)({
  method: 'get',
  url: "".concat(base, "/").concat(_sipAccount, "/forwardRules")
});
exports.$getAllForwardsRules = $getAllForwardsRules;
var $getForwardRule = (_sipAccount, _forwardRule) => (0, _oldHttpClient.apiClient)({
  method: 'get',
  url: "".concat(base, "/").concat(_sipAccount, "/forwardRules/").concat(_forwardRule)
});
exports.$getForwardRule = $getForwardRule;
var $postForwardRule = (_sipAccount, body) => (0, _oldHttpClient.apiClient)({
  method: 'post',
  url: "".concat(base, "/").concat(_sipAccount, "/forwardRules"),
  body
});
exports.$postForwardRule = $postForwardRule;
var $patchForwardRule = (_sipAccount, _forwardRule, body) => (0, _oldHttpClient.apiClient)({
  method: 'patch',
  url: "".concat(base, "/").concat(_sipAccount, "/forwardRules/").concat(_forwardRule),
  body
});
exports.$patchForwardRule = $patchForwardRule;
var $postBulkForwardsRules = (_sipAccount, body) => (0, _oldHttpClient.apiClient)({
  method: 'post',
  url: "".concat(base, "/").concat(_sipAccount, "/forwardRules/bulk"),
  body
});
exports.$postBulkForwardsRules = $postBulkForwardsRules;